import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { firestore } from "../firebaseConfig";
import ConceptSelectorModal from "./ConceptSelectorModal";
import MaterialListModal from "./MaterialListModal";
import PerdeTagModal from "../components/PerdeTagModal"; // ✅ janti perde modalı
import GeriButonu from "../components/GeriButonu";
import { useAlert } from "../context/AlertContext";

function EditReservation() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showSuccess, showError } = useAlert();

  const [customerName, setCustomerName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [location, setLocation] = useState("");
  const [notes, setNotes] = useState("");
  const [selectedConcept, setSelectedConcept] = useState("");
  const [rentedItems, setRentedItems] = useState([]);
  const [perdeTag, setPerdeTag] = useState(false);

  const [isConceptModalOpen, setIsConceptModalOpen] = useState(false);
  const [isMaterialModalOpen, setIsMaterialModalOpen] = useState(false);
  const [isPerdeModalOpen, setIsPerdeModalOpen] = useState(false);

  const [tempItems, setTempItems] = useState([]);
  const [tempConceptName, setTempConceptName] = useState("");

  useEffect(() => {
    const fetchReservation = async () => {
      try {
        const docRef = doc(firestore, "reservations", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setCustomerName(data.customerName || "");
          setPhoneNumber(data.phoneNumber || "");
          setEventDate(data.eventDate || "");
          setLocation(data.address || "");
          setNotes(data.notes || "");
          setSelectedConcept(data.selectedConcept || "");
          setRentedItems(data.rentedItems || []);
          setPerdeTag(data.perdeTag || false);
        }
      } catch (err) {
        console.error("Veri çekme hatası:", err);
        showError("Veri alınamadı");
      }
    };
    fetchReservation();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const docRef = doc(firestore, "reservations", id);
      await updateDoc(docRef, {
        customerName,
        phoneNumber,
        eventDate,
        selectedConcept,
        rentedItems: rentedItems.filter((item) => item.checked),
        notes,
        address: location,
        perdeTag,
      });
      showSuccess("Rezervasyon güncellendi ✅");
      setTimeout(() => navigate("/"), 1500);
    } catch (err) {
      console.error("Güncelleme hatası:", err);
      showError("Güncelleme başarısız");
    }
  };

  return (
    <div className="reservation-wrapper">
      <GeriButonu />

      <div className="form-box">
        <h2 className="form-title">Rezervasyonu Düzenle</h2>

        <input
          className="form-input"
          type="text"
          placeholder="Müşteri Adı"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
        />
        <input
          className="form-input"
          type="text"
          placeholder="Telefon Numarası"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
        <input
          className="form-input"
          type="date"
          value={eventDate}
          onChange={(e) => setEventDate(e.target.value)}
        />
        <input
          className="form-input"
          type="text"
          placeholder="Konum (Salon adı, adres vs.)"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
        />
        <textarea
          className="form-input"
          placeholder="Notlar (isteğe bağlı)"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />

        <p className="selected-concept">
          Seçilen Konsept: <strong>{selectedConcept || "Henüz seçilmedi"}</strong>
        </p>

        <button onClick={() => setIsConceptModalOpen(true)} className="form-button">
          Konsept Değiştir
        </button>

        <button onClick={handleSubmit} className="form-button">
          Güncelle
        </button>
      </div>

      <ConceptSelectorModal
        isOpen={isConceptModalOpen}
        onClose={() => setIsConceptModalOpen(false)}
        onSelectConceptWithItems={(concept, items) => {
          setTempConceptName(concept);
          setTempItems(items);
          setIsConceptModalOpen(false);
          setIsMaterialModalOpen(true);
        }}
      />

      <MaterialListModal
        isOpen={isMaterialModalOpen}
        defaultItems={tempItems}
        onConfirm={(items) => {
          setSelectedConcept(tempConceptName);
          setRentedItems(items);
          setIsMaterialModalOpen(false);
          setIsPerdeModalOpen(true);
        }}
        onClose={() => setIsMaterialModalOpen(false)}
      />

      <PerdeTagModal
        isOpen={isPerdeModalOpen}
        onClose={() => setIsPerdeModalOpen(false)}
        onSelect={(choice) => {
          setPerdeTag(choice === "evet");
          setIsPerdeModalOpen(false);
        }}
      />
    </div>
  );
}

export default EditReservation;
